import { RangePicker } from "@portal/BaseComponents/DatePicker/AntDatePicker";
import { DateChange } from "@portal/BaseComponents/DatePicker/type";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { Radio, RadioGroup } from "@portal/BaseComponents/Radio/AntRadio";
import { GenericRadioChangeEvent } from "@portal/BaseComponents/Radio/types";
import { Space } from "@portal/BaseComponents/Space/AntSpace";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { RelativeDateRange } from "@portal/util/relative-date-range";
import dayjs from "dayjs";
import {
  DateRangeDropdownOption,
  DateRangeOption,
  DateRangeString,
} from "./type";
import { getDateRange, getDefaultOptions } from "./utils";

const DEFAULT_DATE_FORMAT = "YYYY-MM-DD";

const t = {
  selectCustomRange: "Select Custom Range",
  dateRange: "Date Range",
  selectDateRange: "Select Date Range",
};
interface DateRangeSelectInputProps {
  value: DateRangeString;
  onChange?: (value: DateRangeString) => void;
  options: DateRangeDropdownOption[];
  showCustomRangeSelect: boolean;
  format: string;
}
function DateRangeInput(props: Readonly<Partial<DateRangeSelectInputProps>>) {
  const {
    value,
    format: dateFormat = DEFAULT_DATE_FORMAT,
    options: dateRangeOptions = getDefaultOptions(),
    showCustomRangeSelect = true,
    onChange,
  } = props;
  function onDateRangeTypeChange(
    event: GenericRadioChangeEvent<DateRangeOption>
  ) {
    const selectedRange = event.target.value;

    if (selectedRange === "CUSTOM_RANGE") {
      const newValue = getDateRange(
        { type: RelativeDateRange.THIS_WEEK },
        dateRangeOptions,
        dateFormat
      );
      onChange?.({ ...newValue, type: "CUSTOM_RANGE" });
    } else {
      const newValue = getDateRange(
        { type: selectedRange },
        dateRangeOptions,
        dateFormat
      );

      onChange?.(newValue);
    }
  }

  function onCustomDateRangeChange(args: DateChange) {
    const newValue: DateRangeString = {
      type: "CUSTOM_RANGE",
      from: dayjs(args?.[0]).format(dateFormat),
      to: dayjs(args?.[1]).format(dateFormat),
    };
    onChange?.(newValue);
  }
  return (
    <RadioGroup
      value={value?.type}
      onChange={onDateRangeTypeChange}
      size="large"
    >
      <Space direction="vertical">
        {dateRangeOptions.map((option) => (
          <Radio value={option.id} key={option.id}>
            {option.label}
          </Radio>
        ))}
        {showCustomRangeSelect && (
          <>
            <Radio value="CUSTOM_RANGE">
              <TypographyText>{t.selectCustomRange}</TypographyText>
            </Radio>
            <Flex align="center">
              {value && value.type === "CUSTOM_RANGE" && (
                <RangePicker
                  format={dateFormat}
                  value={[
                    dayjs(value.from, dateFormat),
                    dayjs(value.to, dateFormat),
                  ]}
                  onChange={onCustomDateRangeChange}
                  allowClear={false}
                />
              )}
            </Flex>
          </>
        )}
      </Space>
    </RadioGroup>
  );
}

export { DateRangeInput };
